type CompanyLike = { __typename?: string | null };

export function isEnterprise<T extends CompanyLike>(
  company?: CompanyLike | null | undefined,
): company is T {
  return (
    (company as { __typename?: string })?.__typename?.toUpperCase() ===
    CompanyType.Enterprise.toUpperCase()
  );
}
export function isConsultingCompany<T extends CompanyLike>(
  company?: CompanyLike | null | undefined,
): company is T {
  return (
    (company as { __typename?: string })?.__typename?.toUpperCase() ===
    CompanyType.ConsultingCompany.toUpperCase().replace('_', '')
  );
}

export enum CompanyType {
  Enterprise = 'Enterprise',
  ConsultingCompany = 'ConsultingCompany',
  OrganizationalUnit = 'OrganizationalUnit',
}

export interface CompanyMetadata {
  customQuestionTypes: string[] | null;
  size: number | null;
  sector: string | null;
  annualTurnover: string | null;
  identificationNumber: string | null;
  [key: string]: unknown;
}

export interface CompanyLicense {
  id: string;
  licensesCount: number;
}

export interface BaseCompany {
  id: string;
  name: string;
  country: string | null;
  logo: string | null;
  metadata: CompanyMetadata | null;
  type: CompanyType;
  isDisabled: boolean;
}

export interface BaseCompanyPayload {
  id: string;
  name: string;
  country: string | null;
  logo: string | null;
  metadata: Record<string, unknown> | null;
  type: CompanyType;
  isDisabled: boolean;
}
